<template>
  <div>
    <div style="padding-left: 10px; margin-top: 10px;">
      <a-button icon="cluster" @click="() => (visibleHistory = true)">
        History Approval
      </a-button>
      <a-button
        icon="close"
        type="circle"
        @click="goToList"
        style="margin-left: 10px; float: right; margin-right: 10px;"
      >
      </a-button>
      <a-button
        style="margin-left: 10px;"
        icon="form"
        @click="setVisibleHistoryEdit(true)"
      >
        Log Editting
      </a-button>
    </div>
    <a-skeleton :loading="loading" active :paragraph="{ rows: 6 }">
      <a-row :gutter="[8, 8]" style="padding: 5px; margin: 0;">
        <a-col :xs="24" :lg="12">
          <ThongTinNghiPhep :workLeave="workLeave" />
          <br />
          <BasicCreatedWorkLeave :workLeave="workLeave" />
          <!-- <a-col :xs="24" :lg="10">
          <TrangThai />
        </a-col> -->
        </a-col>

        <a-col :xs="24" :lg="12">
          <InfoTypeWorkLeave :infoTypeWorkLeave="workLeave.typeWorkLeave" />
          <br />
          <InfoWorkShift :workShift="workLeave.workShift" />
        </a-col>
        <a-col :xs="24" :lg="24">
          <ChiTietNgayPhep
            :onUpdatedTotalLeaveDays="onUpdatedTotalLeaveDays"
            :workLeaveDays="workLeave.workLeaveDays || []"
          />
        </a-col>
        <a-col :xs="24" :lg="24">
          <ApprovalWorkLeave :workLeave="workLeave" />
        </a-col>
      </a-row>
    </a-skeleton>

    <a-drawer
      title="History Approval"
      placement="right"
      :visible="visibleHistory"
      @close="() => (visibleHistory = false)"
      :width="600"
    >
      <ListHistoryApproval
        :workLeaveApprovals="workLeave.workLeaveApprovals || []"
      />
    </a-drawer>
    <!-- Lịch sử chỉnh sửa -->
    <a-drawer
      title="Log Edit"
      placement="right"
      :visible="visibleHistoryEdit"
      @close="() => (visibleHistoryEdit = false)"
      :width="500"
    >
      <LogEdittingDetail :workLeaveId="workLeave.id" />
    </a-drawer>
    <!-- Lịch sử chỉnh sửa -->
  </div>
</template>
<script>
import query from "./constant/query";
import ThongTinNghiPhep from "./components/Xem/ThongTinNghiPhep";
import ChiTietNgayPhep from "./components/Xem/chiTietNgayPhep";
import HoatDong from "./components/ChiTiet/HoatDong";
import InfoTypeWorkLeave from "./components/common/infoTypeWorkLeave";
import ApprovalWorkLeave from "./components/Xem/approvalWorkLeave";
import ListHistoryApproval from "./components/Xem/components/listHistoryApproval";
import BasicCreatedWorkLeave from "./components/common/basicCreatedWorkLeave";
import InfoWorkShift from "./components/common/infoWorkShift";
import LogEdittingDetail from "./components/common/LogEdittingDetail";

export default {
  props: {},
  components: {
    ThongTinNghiPhep,
    ChiTietNgayPhep,
    InfoTypeWorkLeave,
    InfoTypeWorkLeave,
    ApprovalWorkLeave,
    ListHistoryApproval,
    BasicCreatedWorkLeave,
    InfoWorkShift,
    LogEdittingDetail,
  },
  data() {
    return {
      form: {},
      workLeave: {},
      loading: false,
      loadingDelete: false,
      loadingSubmitting: false,
      visibleHistory: false,
      visibleHistoryEdit: false,
    };
  },
  created() {
    this.onGetWorkLeave();
  },
  methods: {
    onGetWorkLeave() {
      this.loading = true;
      const { idWorkLeave } = this.$route.params;
      if (!idWorkLeave) {
        throw new Error("Cannot get id work leave");
      }

      this.$apollo
        .query({
          query: query.getApprovalWorkLeave,
          variables: {
            id: idWorkLeave,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getWorkLeave?.id) {
            this.workLeave = { ...data.getWorkLeave };
            let totalLeaveDays = 0;
            if (data.getWorkLeave?.workLeaveDays?.length > 0) {
              for (let i in data.getWorkLeave.workLeaveDays) {
                if (data.getWorkLeave.workLeaveDays[i].totalLeaveDays) {
                  totalLeaveDays +=
                    data.getWorkLeave.workLeaveDays[i].totalLeaveDays;
                }
              }
            }
            if (totalLeaveDays > 0) {
              this.$set(this.workLeave, "totalLeaveDays", totalLeaveDays);
            }
          }

          this.loading = false;
        })
        .catch((err) => {
          console.error("Không lấy được danh sách work leave", err);
        });
    },
    goToList() {
      const { idEmployee } = this.$route.params;
      this.$router.push({ name: "workLeaveEmployee", params: { idEmployee } });
    },
    onUpdatedTotalLeaveDays(totalLeaveDays) {
      if (totalLeaveDays) {
        this.$set(this.workLeave, "totalLeaveDays", totalLeaveDays);
      }
    },
    setVisibleHistoryEdit(bool) {
      this.visibleHistoryEdit = bool;
    },
  },
};
</script>
<style lang="css" scoped></style>
